import { FONT_CATALOG } from './catalog';

/**
 * Loads micro-subsets of every catalogue family purely so the font picker can show
 * each entry set in its own typeface.
 *
 * This uses the Google Fonts CSS API with a `text=` subset: the browser gets ~40 WOFF2
 * files of 1–3 KB each instead of the full TTFs. The rendering pipeline never touches
 * these — it only ever uses the binaries parsed by opentype.js.
 */
const PREVIEW_TEXT = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

let injected = false;

export function ensurePreviewFonts(): void {
  if (injected || typeof document === 'undefined') return;
  injected = true;

  const families = FONT_CATALOG.map((f) => `family=${encodeURIComponent(f.family)}`).join('&');
  const href =
    `https://fonts.googleapis.com/css2?${families}` +
    `&text=${encodeURIComponent(PREVIEW_TEXT)}&display=swap`;

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = href;
  link.dataset.role = 'font-previews';
  document.head.appendChild(link);
}

/** CSS font-family value for a picker row. Falls back to the UI font while loading. */
export function previewFamily(family: string): string {
  return `"${family}", var(--font-ui)`;
}
